import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "./Login";
import {Button, Card, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import Ingredient from "../../model/menudesign/Ingredient";
import {BiAlarm, BiAlarmOff, BiArrowBack, BiPencil, BiPlus, BiRefresh, BiTrash, BiFile  } from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import {GetControlHorariUsuariRegistres} from "../../dao/root/GetControlHorariUsuariRegistres";
import Registre from "../../model/root/Registre";
import {format} from "date-fns";
import ControlHorari from "../../model/root/ControlHorari";
import {VscGraph} from "react-icons/vsc";
import controlHorari from "../../model/root/ControlHorari";
import {PostControlHorari} from "../../dao/root/PostControlHorari";
import {GetControlHorari} from "../../dao/root/GetControlHorari";
import HorarisTreball from "./HorarisTreball";
import RegistreHorariPdfModal from './component/RegistreHorariPdfModal';



const EstadistiquesHoraries = () => {
    const titol: string = "Estadístiques Control Horari";
    const nomPermis: string = "Control Horari";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id_usuari, empresa} = useParams();

    const [coleccio, setDades] = useState<Registre[]>([]);
    const [elementSelected, setElementSelected] = useState<Registre>(new Registre());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);
    const [pdfEstadistiques, setpdfEstadistiques] = useState(false);



    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());


    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkDades();
        }
    }, [id_usuari]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetControlHorariUsuariRegistres(id_usuari, empresa || page);
        setDades(dades);
        //await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    function afegirElement(element: Registre) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: Registre) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    /*function setNameFilters(elements: Registre[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ingredientNames);
    }*/

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };

    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    //<Progress percent={50} steps={3} />

    const columns: ColumnsType<Registre> = [
    {
        key: 'id',
        title: 'ID',
        dataIndex: 'id',
        width: 15,
        // responsive: ['lg'],
        sorter: (a, b) => a.id - b.id,
    },
    {
        key: 'moment',
        title: 'Moment',
        dataIndex: 'moment',
        width: 15,
        // responsive: ['lg'],
        render: (_, ele) => {
            try {
                const dateStr = ele.moment ? ele.moment.replace(' ', 'T') : null;
                const date = dateStr ? new Date(dateStr) : null;
                return (
                    <Tag color={Colors.colors.color2}>
                        {date && !isNaN(date.getTime()) ? format(date, 'dd/MM/yyyy HH:mm') : 'Sense data'}
                    </Tag>
                );
            } catch (e) {
                return <Tag color="gray">Error</Tag>;
            }
        },
    },
    {
        key: 'tipus',
        title: 'Entrada/Sortida',
        dataIndex: 'tipus',
        width: 15,
        // responsive: ['lg'],
        render: (_, ele) => (
            <Tag color={ele.tipus === 1 ? Colors.colors.color1 : Colors.colors.color4}>
                {ele.tipus === 1 ? "Entrada" : "Sortida"}
            </Tag>
        )
    },
    {
        key: 'lloc',
        title: 'Lloc',
        dataIndex: 'lloc',
        width: 15,
        // responsive: ['lg'],
    },
     /*{
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                            {" "}
                            <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                                    onClick={() => deleteElement(ele.id)}><BiTrash/></Button>
                            {" "}
                        </>
                    )}
                    <Button title={"Veure Plats"} style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },*/

    
];

    const tableProps: TableProps<Registre> = {
        loading
    };

    const onChange: TableProps<Registre>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    function back() {
        window.history.back();
    }
     function handleCloseModal(refresh: boolean) {
        setpdfEstadistiques(false);
    }


    if (isLoggedIn) {
        return (
            <div>
                <NavBar/>
                <div className={"general"}>
                    <HorarisTreball />
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Enrere"} style={{backgroundColor: Colors.colors.color1}} onClick={() =>
                                back()}><BiArrowBack/></Button>
                            {permisosEdicio &&
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(elementSelected)}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                            <Button title={"Descarrega PDF"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                setpdfEstadistiques(true)}><BiFile  /></Button>
                        </div>
                        <h4 className={"titol"}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                rowKey="id" 
                                onChange={onChange}
                                columns={columns}
                                expandable={{
                                    rowExpandable: (record) => true,
                                }}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    {pdfEstadistiques && (
                        <RegistreHorariPdfModal onClose={handleCloseModal} visible={pdfEstadistiques} />
                    )}

                </div>
            </div>
            
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default EstadistiquesHoraries;
